export default __webpack_public_path__ + "static/media/distributor_banner_v2.c1a113ba.png";